module.exports = __webpack_public_path__ + "a75dc8214098a585c9ad05988db10424.svg";